import React from "react";

const Loader = ({ mt, height = "50px", width = "50px", ml = "45%" }) => {
  const marginTopValue = mt ? mt : "30%";
  return (
    <>
      <div className="loader-view" style={{ marginTop: marginTopValue }}>
        <img
          height={height}
          width={width}
          src="/images/loder.svg"
          style={{ marginLeft: ml }}
        />
      </div>
    </>
  );
};

export default Loader;
